import { render, staticRenderFns } from "./denied-workloads.vue?vue&type=template&id=704a50e2&scoped=true&"
import script from "./denied-workloads.vue?vue&type=script&lang=js&"
export * from "./denied-workloads.vue?vue&type=script&lang=js&"
import style0 from "./denied-workloads.vue?vue&type=style&index=0&id=704a50e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704a50e2",
  null
  
)

export default component.exports